/* eslint-disable */
/**
*   PREPAID FOR LOANS FOR RPP / ISD
*
*/
import moment from 'moment'

const DIA_CORTE = 8

var infoPrepaid = {
  fechaPP: null,
  mesAplicable: null,
  cuotaAplicable: null,
  cuotasRestantes: null,
  fechaInicioPeriodo: null,
  fechaFinPeriodo: null,
  diasInteres1: null,
  tasaParcial1: null,
  saldoInicioPeriodo: null,
  intereses1: null,
  prepagoMax: null,
  prepagoMin: null,
  diasInteres2: null,
  tasaParcial2: null,
  intereses2: null,
  montoPP: null,
  aplicadoAPrincipal: null,
  nuevoSaldoPrimerCorte: null,
  nuevoSaldoSegundoCorte: null,
  cuota1: null,
  periodoGraciaSinCuota: null,
  periodoGraciaSaldoTotal: null,
  valorFuturoGracia: null,
  principal2: null,
  prestamoMaxGracia: null
}
var infoLoan = {
  tasaPrestamoMensual: null,
  periodoGraciaExtraDiferido: null,
  prestamoMaxCuota: null,
  prestamoMaxGracia: null,
  prestamoParaCuota: null,
  valorFuturoDeGracia: null,
  cuotaGracia: null
}
var PV = function (rate, periods, payment, future, type) {
  // Initialize type
  var type = (typeof type === 'undefined') ? 0 : type

  // Evaluate rate and periods (TODO: replace with secure expression evaluator)
  rate = eval(rate)
  periods = eval(periods)

  // Return present value
  if (rate === 0) {
    return - payment * periods - future
  } else {
    return (((1 - Math.pow(1 + rate, periods)) / rate) * payment * (1 +rate * type) - future) / Math.pow(1 + rate, periods)
  }
}
var FV = function (rate, nper, pmt, pv, type) {
  // eslint-disable-next-line
  var pow = Math.pow(1 + rate, nper), fv
  if (rate) {
    fv = (pmt * (1 + rate * type) * (1 - pow) / rate) - pv * pow
  } else {
    fv = -1 * (pv + pmt * nper)
  }
  return fv.toFixed(2)
}
var PMT = function (rate, nperiod, pv, fv, type) {
  if (!fv) fv = 0
  if (!type) type = 0

  if (rate === 0) return -(pv + fv)/nperiod

  var pvif = Math.pow(1 + rate, nperiod)
  var pmt = rate / (pvif - 1) * -(pv * pvif + fv)

  if (type === 1) {
    pmt /= (1 + rate)
  }

  return pmt
}
var roundNumber = function (rnum, rlength) { 
  var newnumber = Math.round(rnum * Math.pow(10, rlength)) / Math.pow(10, rlength)
  return newnumber;
}
var prepaid = {
  getCuotaAplicable (data) {
    let fechaPP = moment(data.fechaPP) // FECHA DE SOLICITUD DE PREPAGO - Ej. 19/06/2020 convert to 2020-06-19
    infoPrepaid.fechaPP = fechaPP
    // SE CALCULAN PARTE DE LOS DATOS DE PRE-PAGOS
    let arrFechaPP = data.fechaPP.split('-')
    if (parseInt(arrFechaPP[2]) <= DIA_CORTE) {
      infoPrepaid.fechaFinPeriodo = infoPrepaid.fechaPP.clone().set('date', DIA_CORTE)
    } else {
      infoPrepaid.fechaFinPeriodo = infoPrepaid.fechaPP.clone().add(1, 'months').set('date', DIA_CORTE)
    }  

    //AJUSTE DE MES PARA VALIDAR DICIEMBRE
    let fechaFinPeriodo = ''
    //let fechaFinPeriodo = moment(parseInt(arrFechaPP[0]) + '-' + (parseInt(arrFechaPP[2]) <= DIA_CORTE ? parseInt(arrFechaPP[1]) : parseInt(arrFechaPP[1])) + '-' + ('0' + DIA_CORTE).slice(-2))
    if(parseInt(arrFechaPP[2]) <= DIA_CORTE){
      fechaFinPeriodo = moment(parseInt(arrFechaPP[0]) + '-' +  parseInt(arrFechaPP[1]) + '-' + ('0' + DIA_CORTE).slice(-2))
    }else{
      let auxMonth = parseInt(arrFechaPP[1]) + 1
      let year = (auxMonth <= 12) ? parseInt(arrFechaPP[0]) : parseInt(arrFechaPP[0]) + 1
      let month = (auxMonth <= 12) ? auxMonth : '01'
      fechaFinPeriodo = moment(year + '-' + month+ '-' + ('0' + DIA_CORTE).slice(-2))
    }

    let arrFechaFinPeriodo = fechaFinPeriodo.format('YYYY-MM-DD').split('-')
    infoPrepaid.mesAplicable = moment(arrFechaFinPeriodo[0] + '-' + ('0' + arrFechaFinPeriodo[1]).slice(-2) + '-01')
    let fechaInicioPrestamo = data.inicioPoliza.clone().add(data.mesInicioPrestamo - 1, 'months').startOf('month')
    let fechaPagoPrestamo =  null
    if (data.fechaInicioPago.isSameOrAfter(fechaInicioPrestamo)) {
      fechaPagoPrestamo = data.fechaInicioPago
    } else {
      fechaPagoPrestamo = fechaInicioPrestamo
    }
    infoPrepaid.cuotaAplicable = infoPrepaid.mesAplicable.diff(fechaInicioPrestamo, 'months') + 1
    // APLICANDO LOGICA DE LA FUNC SIFECHA DE EXCEL
    if (infoPrepaid.fechaFinPeriodo.isSame(fechaPagoPrestamo, 'month')) {
      infoPrepaid.periodoGraciaSaldoTotal = 0
      infoPrepaid.periodoGraciaSinCuota = 0
    } else if (infoPrepaid.fechaFinPeriodo.isAfter(fechaPagoPrestamo)) {
      infoPrepaid.periodoGraciaSaldoTotal = 0
      infoPrepaid.periodoGraciaSinCuota = 0
    } else {
      infoPrepaid.periodoGraciaSaldoTotal = fechaPagoPrestamo.diff(infoPrepaid.fechaFinPeriodo.clone().set('date', 1), 'months')
      infoPrepaid.periodoGraciaSinCuota = fechaPagoPrestamo.diff(infoPrepaid.fechaFinPeriodo.clone().set('date', 1), 'months') - 1
    }
    // APLICANDO LOGICA DE LA FUNC SIFECHA DE EXCEL
    // VERIFICAR SI YA ESTA CALCULADO ESTE DATO PREVIAMENTE.
    if (infoLoan.periodoGraciaExtraDiferido != null) {
      data.numeroCuotas += infoLoan.periodoGraciaExtraDiferido
    }
    infoPrepaid.cuotasRestantes = data.numeroCuotas - infoPrepaid.cuotaAplicable - infoPrepaid.periodoGraciaSinCuota
    let cuotaCronogramaAplicable = infoPrepaid.cuotaAplicable < 1 ? 0 : infoPrepaid.cuotaAplicable - 1
    let saldoInicialPeriodo = parseFloat(data.cronograma[cuotaCronogramaAplicable].saldoInicial.replace(',', ''))
    infoPrepaid.fechaInicioPeriodo = infoPrepaid.fechaFinPeriodo.clone().subtract(1, 'months').add(1, 'days')
    infoPrepaid.diasInteres1 = infoPrepaid.fechaPP.diff(infoPrepaid.fechaInicioPeriodo, 'days')
    infoPrepaid.tasaParcial1 = Math.pow(1 + data.tasaPrestamoAnual, infoPrepaid.diasInteres1/360) - 1
    infoPrepaid.saldoInicioPeriodo = saldoInicialPeriodo // Saldo inicial en el periodo de prestamo del cronograma prestamos
    infoPrepaid.intereses1 = infoPrepaid.saldoInicioPeriodo * infoPrepaid.tasaParcial1
    infoPrepaid.prepagoMax = infoPrepaid.saldoInicioPeriodo + infoPrepaid.intereses1

    return {
      cuotaAplicable: infoPrepaid.cuotaAplicable,
      cuotasRestantes: infoPrepaid.cuotasRestantes,
      fechaInicioPrestamo: fechaInicioPrestamo,
      prepagoMax: infoPrepaid.prepagoMax
    }
  },
  setInfoDataPrepaid (data) {
    let tasaPrestamoMensual = Math.pow(1 + data.tasaPrestamoAnual, 1/12) - 1
    infoPrepaid.montoPP = data.montoPP // Monto deseado a prepagar
    infoPrepaid.prepagoMin = roundNumber(infoPrepaid.saldoInicioPeriodo*0.1, 2)

    infoPrepaid.diasInteres2 = infoPrepaid.fechaFinPeriodo.diff(infoPrepaid.fechaPP, 'days') + 1
    infoPrepaid.tasaParcial2 = Math.pow(1 + data.tasaPrestamoAnual, infoPrepaid.diasInteres2/360) - 1
    infoPrepaid.aplicadoAPrincipal = infoPrepaid.montoPP - infoPrepaid.intereses1
    infoPrepaid.nuevoSaldoPrimerCorte = infoPrepaid.saldoInicioPeriodo - infoPrepaid.aplicadoAPrincipal
    infoPrepaid.intereses2 = infoPrepaid.nuevoSaldoPrimerCorte * infoPrepaid.tasaParcial2
    if (infoPrepaid.periodoGraciaSaldoTotal > 0) {
      infoPrepaid.cuota1 = 0  
    } else {
      infoPrepaid.cuota1 = (data.cuotaPrestamo < (infoPrepaid.nuevoSaldoPrimerCorte + infoPrepaid.intereses2)) ? data.cuotaPrestamo : (infoPrepaid.nuevoSaldoPrimerCorte + infoPrepaid.intereses2)
    }
    infoPrepaid.principal2 = infoPrepaid.cuota1 - infoPrepaid.intereses2
    infoPrepaid.nuevoSaldoSegundoCorte = infoPrepaid.nuevoSaldoPrimerCorte - infoPrepaid.principal2
    infoPrepaid.valorFuturoGracia = -FV(tasaPrestamoMensual, infoPrepaid.periodoGraciaSinCuota, 0, infoPrepaid.nuevoSaldoSegundoCorte, 0) - infoPrepaid.nuevoSaldoSegundoCorte
  },
  calculateInfoPrestamo (data) {
    let tasaPrestamoMensual = Math.pow(1 + data.tasaPrestamoAnual, 1/12) - 1
    //**** INICIO CALCULO DE LA CUOTA(+GRACIA) ORIGEN DE PRESTAMOS ****//
    var numeroMaxCuotas = data.periodoGarantizado - (data.mesInicioPrestamo - 1)
    var cuotaMaxima = data.ingresoMensual
    // PERIODO GRACIA EXTRA DIFERIDO
    var periodoGraciaExtraDiferido = 0
    if ((data.periodosDiferidos - (data.mesInicioPrestamo - 1)) < 0) {
      periodoGraciaExtraDiferido = 0
    } else {
      periodoGraciaExtraDiferido = data.periodosDiferidos - (data.mesInicioPrestamo - 1)
    }
    // PRESTAMNO MAXIMO CUOTA
    var prestamoMaxCuota = 0
    if (data.periodoGarantizado == data.periodosDiferidos) {
      prestamoMaxCuota = -PV(tasaPrestamoMensual, (numeroMaxCuotas - periodoGraciaExtraDiferido), 0, cuotaMaxima, 0)
    } else {
      prestamoMaxCuota = -PV(tasaPrestamoMensual, (numeroMaxCuotas - periodoGraciaExtraDiferido), cuotaMaxima, 0, 0)
    }
    // PRESTAMO MAXIMO GRACIA
    var prestamoMaxGracia = 0
    if (data.periodoGarantizado == data.periodosDiferidos) {
      prestamoMaxGracia = -PV(tasaPrestamoMensual, periodoGraciaExtraDiferido + 1, 0, prestamoMaxCuota, 0)
    } else {
      prestamoMaxGracia = -PV(tasaPrestamoMensual, periodoGraciaExtraDiferido, 0, prestamoMaxCuota, 0)
    }
    var prestamoParaCuota = Math.min(data.montoPrestamo, prestamoMaxGracia)
    // VALOR FUTURO GRACIA
    var valorFuturoDeGracia = 0
    if (data.periodoGarantizado == data.periodosDiferidos) {
      valorFuturoDeGracia = -FV(tasaPrestamoMensual, periodoGraciaExtraDiferido + 1, 0, Math.min(data.montoPrestamo, prestamoMaxGracia), 0) - Math.min(data.montoPrestamo, prestamoMaxGracia)
    } else {
      valorFuturoDeGracia = -FV(tasaPrestamoMensual, periodoGraciaExtraDiferido, 0, Math.min(data.montoPrestamo, prestamoMaxGracia), 0) - Math.min(data.montoPrestamo, prestamoMaxGracia)
    }
    // CUOTA DE GRACIA
    var cuotaGracia = 0
    if (data.periodoGarantizado == data.periodosDiferidos) {
      cuotaGracia = prestamoParaCuota + valorFuturoDeGracia
    } else {
      cuotaGracia = -PMT(tasaPrestamoMensual, (data.numeroCuotas + periodoGraciaExtraDiferido) - periodoGraciaExtraDiferido, prestamoParaCuota + valorFuturoDeGracia, 0, 0)
    }
    //**** FIN CALCULO DE LA CUOTA(+GRACIA) ORIGEN DE PRESTAMOS ****//
    infoLoan.tasaPrestamoMensual = tasaPrestamoMensual
    infoLoan.periodoGraciaExtraDiferido = periodoGraciaExtraDiferido
    infoLoan.prestamoMaxCuota = prestamoMaxCuota
    infoLoan.prestamoMaxGracia = prestamoMaxGracia
    infoLoan.prestamoParaCuota = prestamoParaCuota
    infoLoan.valorFuturoDeGracia = valorFuturoDeGracia
    infoLoan.cuotaGracia = cuotaGracia

    return {
      tasaPrestamoMensual: infoLoan.tasaPrestamoMensual,
      periodoGraciaExtraDiferido: infoLoan.periodoGraciaExtraDiferido,
      prestamoMaxCuota: infoLoan.prestamoMaxCuota,
      cuotaGracia: infoLoan.cuotaGracia
    }
  },
  getInputsMontoPrimeroDevolucion (data) {
    let tasaPrestamoMensual = Math.pow(1 + data.tasaPrestamoAnual, 1/12) - 1
    let vaCuotas1D = -PV(tasaPrestamoMensual, infoPrepaid.cuotasRestantes, infoLoan.cuotaGracia, 0, 0)
    let prestamoSoloCuota = Math.min(infoPrepaid.nuevoSaldoSegundoCorte + infoPrepaid.valorFuturoGracia, vaCuotas1D)
    let prestamoParaDevolucion = (infoPrepaid.nuevoSaldoSegundoCorte + infoPrepaid.valorFuturoGracia) - prestamoSoloCuota
    let vfPrestamoAdicional = -FV(tasaPrestamoMensual, infoPrepaid.cuotasRestantes + 1, 0, prestamoParaDevolucion, 0)
    let devolucionFinal = data.devolucionFinal - vfPrestamoAdicional
    let cuota2 = -PMT(tasaPrestamoMensual, infoPrepaid.cuotasRestantes, prestamoSoloCuota, 0, 0)
    let cuotasRestantes = infoPrepaid.cuotasRestantes
    if (cuota2 < 1) { cuotasRestantes = 0 }
    return {
      vaCuotas1D: vaCuotas1D,
      prestamoSoloCuota: prestamoSoloCuota,
      prestamoParaDevolucion: prestamoParaDevolucion,
      vfPrestamoAdicional: vfPrestamoAdicional,
      devolucionFinal: devolucionFinal,
      cuotasRestantes: cuotasRestantes,
      cuota2: cuota2
    }
  },
  getInputsMontoPrimeroRentas (data) {
    let tasaPrestamoMensual = Math.pow(1 + data.tasaPrestamoAnual, 1/12) - 1
    //**** CALCULO DEL PRESTAMO MAXIMO CUOTA DE PRESTAMOS PARA OBTENER UN VALOR ****//
    let prestamoParaCuota = Math.min(data.montoPrestamo, infoLoan.prestamoMaxGracia)
    let valorFuturoPrestamoAdicional = -FV(tasaPrestamoMensual, data.temporalidad + 1 - data.mesInicioPrestamo - 1, 0, data.montoPrestamo > prestamoParaCuota ? data.montoPrestamo - prestamoParaCuota : 0, 0)
    //**** CALCULO DEL PRESTAMO MAXIMO CUOTA DE PRESTAMOS PARA OBTENER UN VALOR ****//
    let vaDevolucion = -PV(tasaPrestamoMensual, infoPrepaid.cuotasRestantes + 1, 0, valorFuturoPrestamoAdicional, 0)
    let prestamoParaDevolucion = Math.min(infoPrepaid.nuevoSaldoSegundoCorte, vaDevolucion)
    let prestamoSoloCuota = infoPrepaid.nuevoSaldoSegundoCorte - prestamoParaDevolucion
    let vfPrestamoAdicional = -FV(tasaPrestamoMensual, data.temporalidad + 1 - data.mesInicioPrestamo - 1 - infoPrepaid.cuotaAplicable, 0, prestamoParaDevolucion)
    if (Number.isNaN(vfPrestamoAdicional)) vfPrestamoAdicional = 0
    let devolucionFinal = data.devolucionFinal - vfPrestamoAdicional 
    let cuota2 = -PMT(tasaPrestamoMensual, infoPrepaid.cuotasRestantes, prestamoSoloCuota)

    return {
      tasaPrestamoMensual: tasaPrestamoMensual,
      vaDevolucion: vaDevolucion,
      prestamoParaDevolucion: prestamoParaDevolucion,
      prestamoSoloCuota: prestamoSoloCuota,
      vfPrestamoAdicional: vfPrestamoAdicional,
      devolucionFinal: devolucionFinal,
      cuota2: cuota2
    }
  },
  getInputsPlazoPrimeroDevolucion (data, inputsPrimeroDevolucion) {
    let tasaPrestamoMensual = Math.pow(1 + data.tasaPrestamoAnual, 1/12) - 1
    let cuotaMin = Math.ceil(Math.log(1/(1 - ((inputsPrimeroDevolucion.prestamoSoloCuota) * tasaPrestamoMensual) / infoLoan.cuotaGracia )) / Math.log(1 + tasaPrestamoMensual))
    let cuotaFinal = cuotaMin + infoPrepaid.cuotaAplicable

    return {
      periodoGraciaSinCuota: infoPrepaid.periodoGraciaSinCuota,
      cuotaMin: cuotaMin,
      cuotaFinal: cuotaFinal
    }
  },
  getInputsPlazoPrimeroRentas (data, inputsPrimeroRentas) {
    let periodoDeGraciaExtra = 0
    let tasaPrestamoMensual = Math.pow(1 + data.tasaPrestamoAnual, 1/12) - 1
    let valorFuturoGracia = 0
    let cuotaMin = roundNumber(Math.log(1/(1 - ((inputsPrimeroRentas.prestamoSoloCuota + valorFuturoGracia) * tasaPrestamoMensual) / infoPrepaid.cuota1 )) / Math.log(1 + tasaPrestamoMensual), 0) + periodoDeGraciaExtra
    let cuotaFinal = cuotaMin + infoPrepaid.cuotaAplicable
    let vaDevolucionFinCuotas = -PV(tasaPrestamoMensual, data.cuotaPrestamo + 1 - cuotaFinal, 0, inputsPrimeroRentas.vfPrestamoAdicional , 0)

    return {
      cuotaMin: cuotaMin,
      cuotaFinal: cuotaFinal,
      vaDevolucionFinCuotas: vaDevolucionFinCuotas
    }
  },
  makeCronoPrimeroDevolucionMonto (data, inputsPrimeroDevolucion) {
    let tasaPrestamoMensual = Math.pow(1 + data.tasaPrestamoAnual, 1/12) - 1
    let cronograma = []
    var periodoPrestamo = null
    var periodoPoliza = null
    var fechaInicioPoliza = moment(data.inicioPoliza)
    var fechaFinPrestamo = moment(data.fechaFinPago)
    var fechaInicioPrestamo = fechaInicioPoliza.clone().add(data.mesInicioPrestamo - 1, 'months').startOf('month')
    var inicioPagoPrestamo = fechaInicioPrestamo.diff(fechaInicioPoliza) > -1 ? fechaInicioPrestamo : fechaInicioPoliza
    if ( data.periodoGarantizado == data.periodosDiferidos ) {
      if ( infoPrepaid.cuotaAplicable <= data.periodoGarantizado - data.mesInicioPrestamo + 2 ) {
        periodoPrestamo = infoPrepaid.cuotaAplicable
      } else {
        periodoPrestamo = 1
      }
    } else {
      if ( data.montoPrestamo > infoPrepaid.prestamoMaxGracia ) {
        if ( infoPrepaid.cuotaAplicable <= data.periodoGarantizado - data.mesInicioPrestamo + 2 ) {
          periodoPrestamo = infoPrepaid.cuotaAplicable
        } else {
          periodoPrestamo = 1
        }
      } else {
        if ( infoPrepaid.cuotaAplicable <= (data.numeroCuotas + infoLoan.periodoGraciaExtraDiferido) ) {
          periodoPrestamo = infoPrepaid.cuotaAplicable
        } else {
          periodoPrestamo = 1
        }
      }
    }
    let cuotaCronogramaAplicable = infoPrepaid.cuotaAplicable == 0 ? 0 : infoPrepaid.cuotaAplicable - 1
    periodoPoliza = data.cronogramaCuotaAplicable[cuotaCronogramaAplicable].periodoPoliza
    var calendario = fechaInicioPrestamo.add(periodoPrestamo - 1, 'months')
    var saldoInicial = parseFloat(data.cronogramaCuotaAplicable[cuotaCronogramaAplicable].saldoInicial.replace('$', '').replace('S/', '').replace(',', ''))
    var interes = infoPrepaid.intereses1 + infoPrepaid.intereses2
    var principal = null
    if (infoPrepaid.aplicadoAPrincipal + infoPrepaid.principal2 < saldoInicial) {
      principal = infoPrepaid.aplicadoAPrincipal + infoPrepaid.principal2
    } else {
      principal = saldoInicial
    }
    var cuota = roundNumber(interes + principal, 2)
    var saldoFinal = saldoInicial + interes - cuota
    /** Calculo de cada columna inicial */
    let calendarioFecha = calendario.locale('es').format('YYYY-MM-01')
    let calendarioText = calendario.locale('es').format('MMM-YYYY').replace('.', '')
    calendarioText = calendarioText.charAt(0).toUpperCase() + calendarioText.slice(1)
    let IGV = Math.ceil((interes / 1.18 * 0.18) * 100) / 100
    let pagos = {
      calendario: calendarioText,
      calendarioFecha: calendarioFecha,
      periodoPoliza: periodoPoliza,
      periodoPrestamo: periodoPrestamo,
      saldoInicial: saldoInicial,
      IGV: IGV,
      intIS: interes - IGV,
      interes: interes,
      principal: principal,
      cuota: cuota,
      saldoFinal: Math.abs(saldoFinal),
      interesPrepago: roundNumber(infoPrepaid.intereses1, 2),
      principalPrepago: roundNumber(infoPrepaid.aplicadoAPrincipal, 2),
      igvPrepago: Math.ceil((infoPrepaid.intereses1 / 1.18 * 0.18) * 100) / 100,
      interesIPrepago: roundNumber(infoPrepaid.intereses1 - (Math.ceil((infoPrepaid.intereses1 / 1.18 * 0.18) * 100) / 100), 2)
    }
    cronograma.push(pagos)
    /** Calculo de las demas columnas */
    let cuotasIterables = inputsPrimeroDevolucion.vfPrestamoAdicional > 0 ? infoPrepaid.cuotasRestantes + 1 : infoPrepaid.cuotasRestantes
    cuotasIterables = inputsPrimeroDevolucion.cuota2 > 0.1 ? cuotasIterables : 0
    for (let index = 0; index < cuotasIterables; index++) {
      periodoPoliza++
      periodoPrestamo++
      saldoInicial = saldoFinal
      calendario = calendario.add(1, 'months')
      interes = tasaPrestamoMensual * saldoInicial
      // CALCULO DE CUOTA
      let periodoDeGraciaExtra = 0
      if (periodoPrestamo < data.periodosDiferidos - data.mesInicioPrestamo - 1) {
        periodoDeGraciaExtra = 0
      } else {
        periodoDeGraciaExtra = data.periodosDiferidos - data.mesInicioPrestamo - 1
      }
      if ( periodoPrestamo <= periodoDeGraciaExtra ) {
        cuota = 0
      } else {
        if (periodoPrestamo > (data.numeroCuotas + infoLoan.periodoGraciaExtraDiferido)) {
          if (periodoPoliza == data.periodoGarantizado + 1) {
            if (data.periodoGarantizado == data.periodosDiferidos) {
              cuota = inputsPrimeroDevolucion.vfPrestamoAdicional  + inputsPrimeroDevolucion.cuota2
            } else {
              cuota = inputsPrimeroDevolucion.vfPrestamoAdicional 
            }
          } else {
            cuota = 0
          }
        } else {
          if (periodoPrestamo == (data.numeroCuotas + infoLoan.periodoGraciaExtraDiferido)) {
            if (infoPrepaid.nuevoSaldoSegundoCorte >= inputsPrimeroDevolucion.vaCuotas1D) {
              cuota = inputsPrimeroDevolucion.cuota2
            } else {
              cuota = saldoInicial*(1+tasaPrestamoMensual)
            }
          } else {
            cuota = inputsPrimeroDevolucion.cuota2
          }
        }
      }
      // CALCULO DE CUOTA
      cuota = roundNumber(cuota, 2)
      principal = cuota - interes
      saldoFinal = saldoInicial + interes - cuota
      // A VECES SALE UN VALOR ENTRE -0.01 a 0.01. Estos debes ser redondeados a 0
      if (saldoFinal < 0.01) {
        saldoFinal = 0
      }
      let calendarioFecha = calendario.local('es').format('YYYY-MM-01')
      let calendarioText = calendario.locale('es').format('MMM-YYYY').replace('.', '')
      calendarioText = calendarioText.charAt(0).toUpperCase() + calendarioText.slice(1)
      let IGV = Math.ceil((interes / 1.18 * 0.18) * 100) / 100
      let pagos = {
        calendario: calendarioText,
        calendarioFecha: calendarioFecha,
        periodoPoliza: periodoPoliza,
        periodoPrestamo: periodoPrestamo,
        saldoInicial: saldoInicial,
        IGV: IGV,
        intIS: interes - IGV,
        interes: interes,
        principal: principal,
        cuota: cuota,
        saldoFinal: Math.abs(saldoFinal)
      }
      cronograma.push(pagos)
    }
    
    return cronograma
  },
  makeCronoPrimeroDevolucionPlazo (data, inputsMontoPrimeroDevolucion, inputsPlazoPrimeroDevolucion) {
    let tasaPrestamoMensual = Math.pow(1 + data.tasaPrestamoAnual, 1/12) - 1
    let cronograma = []
    var periodoPrestamo = null
    var periodoPoliza = null
    var fechaInicioPoliza = moment(data.inicioPoliza)
    var fechaFinPrestamo = moment(data.fechaFinPago)
    var fechaInicioPrestamo = fechaInicioPoliza.add(data.mesInicioPrestamo - 1, 'months').startOf('month')
    var inicioPagoPrestamo = fechaInicioPrestamo.diff(fechaInicioPoliza) > -1 ? fechaInicioPrestamo : fechaInicioPoliza
    if ( data.periodoGarantizado == data.periodosDiferidos ) {
      if ( infoPrepaid.cuotaAplicable <= data.periodoGarantizado - data.mesInicioPrestamo + 2 ) {
        periodoPrestamo = infoPrepaid.cuotaAplicable
      } else {
        periodoPrestamo = 1
      }
    } else {
      if ( inputsMontoPrimeroDevolucion.vfPrestamoAdicional > 0 ) {
        if ( infoPrepaid.cuotaAplicable <= data.periodoGarantizado - data.mesInicioPrestamo + 2 ) {
          periodoPrestamo = infoPrepaid.cuotaAplicable
        } else {
          periodoPrestamo = 1
        }
      } else {
        if ( infoPrepaid.cuotaAplicable <= inputsPlazoPrimeroDevolucion.cuotaFinal ) {
          periodoPrestamo = infoPrepaid.cuotaAplicable
        } else {
          periodoPrestamo = 1
        }
      }
    }
    let cuotaCronogramaAplicable = infoPrepaid.cuotaAplicable == 0 ? 0 : infoPrepaid.cuotaAplicable - 1
    periodoPoliza = data.cronogramaCuotaAplicable[cuotaCronogramaAplicable].periodoPoliza
    var calendario = fechaInicioPrestamo.add(periodoPrestamo - 1, 'months')
    var saldoInicial = parseFloat(data.cronogramaCuotaAplicable[cuotaCronogramaAplicable].saldoInicial.replace('$', '').replace('S/', '').replace(',', ''))
    var interes = infoPrepaid.intereses1 + infoPrepaid.intereses2
    var principal = null
    if (infoPrepaid.aplicadoAPrincipal + infoPrepaid.principal2 < saldoInicial) {
      principal = infoPrepaid.aplicadoAPrincipal + infoPrepaid.principal2
    } else {
      principal = saldoInicial
    }
    // [NUEVA CUOTA MENSUAL PRESTAMO]
    let nuevaCuotaMensualPrestamo = 0
    if (inputsPlazoPrimeroDevolucion.cuotaMin > 0) {
      nuevaCuotaMensualPrestamo = roundNumber(infoLoan.cuotaGracia, 2)
    }
    // [NUEVA CUOTA MENSUAL PRESTAMO]
    var cuota = roundNumber(interes + principal, 2)
    var saldoFinal = saldoInicial + interes - cuota
    /** Calculo de cada columna inicial */
    let calendarioFecha = calendario.locale('es').format('YYYY-MM-01')
    let calendarioText = calendario.locale('es').format('MMM-YYYY').replace('.', '')
    calendarioText = calendarioText.charAt(0).toUpperCase() + calendarioText.slice(1)
    let IGV = Math.ceil((interes / 1.18 * 0.18) * 100) / 100
    let pagos = {
      calendario: calendarioText,
      calendarioFecha: calendarioFecha,
      periodoPoliza: periodoPoliza,
      periodoPrestamo: periodoPrestamo,
      saldoInicial: saldoInicial,
      IGV: IGV,
      intIS: interes - IGV,
      interes: interes,
      principal: principal,
      cuota: cuota,
      saldoFinal: Math.abs(saldoFinal),
      interesPrepago: roundNumber(infoPrepaid.intereses1, 2),
      principalPrepago: roundNumber(infoPrepaid.aplicadoAPrincipal, 2),
      igvPrepago: Math.ceil((infoPrepaid.intereses1 / 1.18 * 0.18) * 100) / 100,
      interesIPrepago: roundNumber(infoPrepaid.intereses1 - (Math.ceil((infoPrepaid.intereses1 / 1.18 * 0.18) * 100) / 100), 2)
    }
    cronograma.push(pagos)
    let cuotasIterables = (inputsPlazoPrimeroDevolucion.cuotaMin + inputsPlazoPrimeroDevolucion.periodoGraciaSinCuota) > 0.1 ? (inputsPlazoPrimeroDevolucion.cuotaMin + inputsPlazoPrimeroDevolucion.periodoGraciaSinCuota) : 0
    for (let index = 0; index < cuotasIterables; index++) {
      periodoPoliza++
      periodoPrestamo++
      saldoInicial = saldoFinal
      calendario = calendario.add(1, 'months')
      interes = tasaPrestamoMensual * saldoInicial
      // CALCULO DE CUOTA
      let periodoDeGraciaExtra = 0
      if (data.periodosDiferidos - (data.mesInicioPrestamo - 1) < 0) {
        periodoDeGraciaExtra = 0
      } else {
        periodoDeGraciaExtra = data.periodosDiferidos - (data.mesInicioPrestamo - 1)
      }
      if ( periodoPrestamo <= periodoDeGraciaExtra ) {
        cuota = 0
      } else {
        if (periodoPrestamo > (inputsPlazoPrimeroDevolucion.cuotaFinal + infoPrepaid.periodoGraciaSinCuota)) {
          if (periodoPoliza == data.periodoGarantizado + 1) {
            if (data.periodoGarantizado == data.periodosDiferidos) {
              cuota = inputsMontoPrimeroDevolucion.vfPrestamoAdicional + infoLoan.cuotaGracia
            } else {
              cuota = inputsMontoPrimeroDevolucion.vfPrestamoAdicional 
            }
          } else {
            cuota = 0
          }
        } else {
          if (periodoPrestamo == (inputsPlazoPrimeroDevolucion.cuotaFinal + infoPrepaid.periodoGraciaSinCuota)) {
            cuota = saldoInicial*(1+tasaPrestamoMensual)
          } else {
            cuota = infoLoan.cuotaGracia
          }
        }
      }
      // CALCULO DE CUOTA
      cuota = roundNumber(cuota, 2)
      principal = cuota - interes
      saldoFinal = saldoInicial + interes - cuota
      // A VECES SALE UN VALOR ENTRE -0.01 a 0.01. Estos debes ser redondeados a 0
      if (saldoFinal < 0.01) {
        saldoFinal = 0
      }
      let calendarioFecha = calendario.locale('es').format('YYYY-MM-01')
      let calendarioText = calendario.locale('es').format('MMM-YYYY').replace('.', '')
      calendarioText = calendarioText.charAt(0).toUpperCase() + calendarioText.slice(1)
      let IGV = Math.ceil((interes / 1.18 * 0.18) * 100) / 100
      let pagos = {
        calendario: calendarioText,
        calendarioFecha: calendarioFecha,
        periodoPoliza: periodoPoliza,
        periodoPrestamo: periodoPrestamo,
        saldoInicial: saldoInicial,
        IGV: IGV,
        intIS: interes - IGV,
        interes: interes,
        principal: principal,
        cuota: cuota,
        saldoFinal: Math.abs(saldoFinal)
      }
      cronograma.push(pagos)
    }

    return cronograma
  }
}

export default prepaid



// WEBPACK FOOTER //
// ./src/interfaces/prepaid.js